const IS_DEVELOPMENT = process.env.NODE_ENV !== "production";

function buildTypesenseNode() {
  if (IS_DEVELOPMENT) {
    return {
      host: "localhost",
      port: "8108",
      protocol: "http",
    };
  }

  const { hostname, port, protocol } = window.location;

  return {
    host: hostname,
    port: port || (protocol === "https:" ? "443" : "80"),
    protocol: protocol.replace(":", ""),
    path: "/typesense",
  };
}

export const API_ORIGIN = IS_DEVELOPMENT
  ? "http://localhost:3001"
  : window.location.origin;
export const API_BASE = IS_DEVELOPMENT ? `${API_ORIGIN}/api` : "/api";

export const TYPESENSE_SERVER = {
  apiKey: "xyz",
  nodes: [buildTypesenseNode()],
};
